import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectCartItemsCount } from "../../store/cartbodydataslice";
import "../css/Home.css";
import LOGO from "../assets/thurent-logo.svg";
import Services from "./Services";
import { setEventDetails } from "../../store/eventsliceforcart";
import { useTentCart } from "../../hooks/useTentCart";
import { usePriestCart } from "../../hooks/usePriestCart";
import { useCateringCart } from "../../hooks/usecateringcart";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { logOut } from "../../store/authSlice";
import { getToken } from "../../util/Cookies";
import { getRoleFromToken, isTokenExpired } from "../../util/authUtils";
import { fetchEvent } from "../../Apiservices/Auth/servers/fetchEvents";
import {
  addServiceToCart,
  clearEntireCart,
} from "../../store/cartbodydataslice";
import {
  addToCart,
  clearPreistCart,
  clearTenthouseCart,
  clearCateringCart,
} from "../../store/cartSlice";
import {
  getPriestToCartAPI,
  fetchTentCartAPI,
  fetchCateringCartAPI,
} from "../../Apiservices/Auth/cart/Addtocart_api";
function Navbar() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const user = useSelector((state) => state.user.userDetails);
  const token = getToken();
  const role = token ? getRoleFromToken(token) : null;

  // const tentCart = useTentCart();
  // const priestCart = usePriestCart();
  // const cateringCart = useCateringCart();
  const dispatch = useDispatch();
  useEffect(() => {
    let isMounted = true;

    const loadEvents = async () => {
      try {
        const res = await fetchEvent();
        const upcoming = res.upcomingEvents ?? [];
        // console.log("Fetched events response:", res);
        // console.log("Upcoming events:", upcoming);
        if (isMounted) {
          upcoming.forEach((event) => {
            dispatch(
              setEventDetails({
                eventID: event.id,
                eventDetails: event,
              })
            );
          });
        }
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    };
    if (isLoggedIn) {
      loadEvents();
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [showServices, setShowServices] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const logoutAccount = () => {
    dispatch(logOut());
    navigate("/");
    window.location.reload();
  };

  const [isFetching, setIsFetching] = useState(false);

  const fetchPriestCartAndStore = useCallback(async () => {
    try {
      if (!isLoggedIn || role !== "customer") {
        console.warn("Skipping cart fetch — user not logged in");
        return;
      }
      // 1. Call all APIs in parallel
      const [priestRes, tentRes, cateringRes] = await Promise.all([
        getPriestToCartAPI(),
        fetchTentCartAPI(),
        fetchCateringCartAPI(),
      ]);

      // 2. Clear all carts at once BEFORE processing - both cart and cartbody
      dispatch(clearPreistCart());
      dispatch(clearTenthouseCart());
      dispatch(clearCateringCart());
      dispatch(clearEntireCart()); // Clear cartbody

      // 3. Process responses after clearing
      const processingPromises = [];
      // console.log("priestgaudds", priestRes, tentRes, cateringRes);
      // Process Priest Data - Add to both cart and cartbody
      if (priestRes?.success && Array.isArray(priestRes.result)) {
        priestRes.result.forEach((eventItem) => {
          const eventID = eventItem.event_id;
          const eventName = eventItem.event_title;

          eventItem.priestItems.forEach((priestItem) => {
            if (
              priestItem?.priest?.id &&
              priestItem?.service?.id &&
              priestItem?.id !== undefined
            ) {
              // Add to cart slice (for provider checking)
              const cartData = {
                serviceType: "preist",
                eventID,
                providerID: priestItem.priest.id,
                service_id: priestItem.service.id,
                cart_id: priestItem.id,
                price: priestItem.pricing?.price || 0,
                discountprice: priestItem.pricing?.discountPrice || 0,
                quantity: 1,
                discountvalidupto:priestItem.pricing?.discountValidUpto || null,
                is_checked_out: priestItem.is_checked_out || false,
              };
              processingPromises.push(
                Promise.resolve(dispatch(addToCart(cartData)))
              );

              // Add to cartbody slice (for detailed data)
              const cartbodyData = {
                eveId: eventID,
                eventname: eventName,
                type: "priestData",
                item: {
                  is_checked_out: priestItem.is_checked_out,
                  is_edit_allowed: priestItem.is_edit_allowed,
                  paid_amount: priestItem.paid_amount,
                  balance_to_be_paid: priestItem.balance_to_be_paid,
                  is_cancel_in_progress: priestItem.is_cancel_in_progress,
                  is_canceled: priestItem.is_canceled,
                  refund_complete: priestItem.refund_complete,
                  refund_in_pending: priestItem.refund_in_pending,
                  refunded_amount: priestItem.refunded_amount,
                  provider_id: priestItem.priest.id,
                  providername: priestItem.priest.name,
                  price: priestItem.pricing?.price || 0,
                  discountPrice: priestItem.pricing?.discountPrice || 0,
                  validUpto: priestItem.pricing?.discountValidUpto || null,
                  service_id: priestItem.service.id,
                  cart_id: priestItem.id,
                  mobileNumber: priestItem.priest.mobileNumber,
                  ...priestItem
                },
              };
              processingPromises.push(
                Promise.resolve(dispatch(addServiceToCart(cartbodyData)))
              );
            }
          });
        });
      }

      // Process Tenthouse Data - Add to both cart and cartbody
      if (tentRes?.success && Array.isArray(tentRes.data)) {
        tentRes.data.forEach((eventItem) => {
          const eventID = eventItem.event_id;
          const eventName = eventItem.event_title;
          const event_start_date = eventItem.event_start_date;

          eventItem.tent_providers.forEach((tentItem) => {
            if (tentItem?.provider_id && eventID) {
              // Add to cart slice
              const cartData = {
                serviceType: "tenthouse",
                eventID,
                providerID: tentItem.provider_id,
                service_id: null,
                cart_id: tentItem.id || null,
                price: tentItem.price || 0,
                discountprice: tentItem.discount_price || 0,
                quantity: 1,
                discountvalidupto: tentItem.discount_valid_upto || null,
                is_checked_out: tentItem.is_checked_out || false,
              };
              processingPromises.push(
                Promise.resolve(dispatch(addToCart(cartData)))
              );

              // Add to cartbody slice
              const cartbodyData = {
                eveId: eventID,
                eventname: eventName,
                event_start_date: event_start_date,
                type: "tentHouseData",
                item: {
                  provider_id: tentItem.provider_id,
                  balance_to_be_paid: tentItem.balance_to_be_paid,
                  is_checked_out: tentItem.is_checked_out,
                  is_edit_allowed: tentItem.is_edit_allowed,
                  paid_amount: tentItem.paid_amount,
                  providername: `${tentItem.first_name} ${
                    tentItem.lastName || ""
                  }`,
                  is_cancel_in_progress: tentItem.is_cancel_in_progress,
                  is_canceled: tentItem.is_canceled,
                  refund_complete: tentItem.refund_complete,
                  refund_in_pending: tentItem.refund_in_pending,
                  refunded_amount: tentItem.refunded_amount,
                  services: (tentItem.items || []).map((item) => ({
                    cart_id: item.cart_id,
                    mapping_id: item.mapping_id,
                    service_id: item.service_id,
                    quantity: item.quantity,
                    price: item.price,
                    discountPrice: item.discount_price,
                    validUpto: item.discount_valid_upto,
                  })),
                },
              };
              processingPromises.push(
                Promise.resolve(dispatch(addServiceToCart(cartbodyData)))
              );
            }
          });
        });
      }

      // Process Catering Data - Add to both cart and cartbody
      if (cateringRes?.data?.data) {
        cateringRes.data.data.forEach((item) => {
          const eventID = item.event_id;
          const eventName = item.event_title;
          const event_start_date = item.event_start_date;

          item.catering_providers.forEach((cateringitem) => {
            if (cateringitem.provider_id && eventID) {
              cateringitem.items.forEach((cateringItem) => {
                // Add to cart slice
                const cartData = {
                  serviceType: "catering",
                  eventID,
                  providerID: cateringitem.provider_id,
                  service_id: cateringItem.category_id,
                  mapping_id: cateringItem.item_id,
                  cart_id: cateringItem.cart_id || null,
                  price: cateringItem.regular_price || 0,
                  discountprice: cateringItem.discounted_price || 0,
                  quantity: cateringItem.number_of_people || 1,
                  discountvalidupto: cateringItem.valid_until || null,
                  is_checked_out: cateringitem.is_checked_out || false,
                };
                processingPromises.push(
                  Promise.resolve(dispatch(addToCart(cartData)))
                );

                // Add to cartbody slice (one dispatch per provider with all services)
                // We need to group by provider to match your cartbody structure
                const existingProviderIndex = processingPromises.findIndex(
                  (p) =>
                    p.then &&
                    p.providerId === cateringitem.provider_id &&
                    p.eventId === eventID
                );

                if (existingProviderIndex === -1) {
                  const cartbodyData = {
                    eveId: eventID,
                    eventname: eventName,
                    event_start_date: event_start_date,
                    type: "cateringData",
                    item: {
                      provider_id: cateringitem.provider_id,
                      balance_to_be_paid: cateringitem.balance_to_be_paid,
                      is_checked_out: cateringitem.is_checked_out,
                      is_edit_allowed: cateringitem.is_edit_allowed,
                      paid_amount: cateringitem.paid_amount,
                      providername: `${cateringitem.first_name} ${cateringitem.last_name}`,
                      is_cancel_in_progress: cateringitem.is_cancel_in_progress,
                      is_canceled: cateringitem.is_canceled,
                      refund_complete: cateringitem.refund_complete,
                      refund_in_pending: cateringitem.refund_in_pending,
                      refunded_amount: cateringitem.refunded_amount,
                      services: cateringitem.items.map((item) => ({
                        mapping_id: item.item_id,
                        service_id: item.category_id,
                        quantity: item.number_of_people,
                        price: item.regular_price,
                        discountPrice: item.discounted_price,
                        validUpto: item.valid_until,
                        category: item.category?.name,
                        mealtype: item.meal?.name,
                        cuisine: item.type?.name,
                        ...item
                      })),
                    },
                  };

                  const promise = Promise.resolve(
                    dispatch(addServiceToCart(cartbodyData))
                  );
                  promise.providerId = cateringitem.provider_id;
                  promise.eventId = eventID;
                  processingPromises.push(promise);
                }
              });
            }
          });
        });
      }

      // Wait for all cart updates to complete
      await Promise.all(processingPromises);

      // console.log("Cart sync completed successfully");
    } catch (error) {
      console.error("Error while fetching carts:", error);
    }
  }, [dispatch]);

  const refreshKey = useSelector((state) => state.cart.refreshKey);

  useEffect(() => {
    if (!isLoggedIn || role !== "customer") return; // ⛔ Do nothing if not logged in

    if (!isFetching) {
      setIsFetching(true);
      fetchPriestCartAndStore().finally(() => setIsFetching(false));
    }
  }, [isLoggedIn, role, fetchPriestCartAndStore]);

  const totalCount = useSelector(selectCartItemsCount);
  const whysa = useSelector((state) => state.cart);
  const whysosi = useSelector((state) => state.cartbodyslice.cart);
  // console.log("isLoggedIn", totalCount, whysa, whysosi);

  return (
    <>
      <div className="th-nav">
        <div
          className="th-nav__logo"
          onClick={() => {
            if (isLoggedIn) {
              switch (role) {
                case "customer":
                  navigate("/dashboard");
                  break;
                case "provider":
                  navigate("/service-provider/dashboard");
                  break;
                case "admin":
                  navigate("/admin-dashboard");
                  break;
                default:
                  navigate("/"); // fallback
              }
            } else {
              navigate("/");
            }
          }}
        >
          <img src={LOGO} alt="thurent" width={"120px"} />
          <span>AI Powered Events Platform</span>
        </div>
        <div className="th-nav__menu">
          <span
            className={`cursor-pointer ${
              location.pathname === "/" && !showServices
                ? "th-nav__link__active"
                : "th-nav__link"
            }`}
            onClick={() => {
              if (isLoggedIn) {
                switch (role) {
                  case "customer":
                    navigate("/dashboard");
                    break;
                  case "provider":
                    navigate("/service-provider/dashboard");
                    break;
                  case "admin":
                    navigate("/admin-dashboard");
                    break;
                  default:
                    navigate("/"); // fallback
                }
              } else {
                navigate("/");
              }
            }}
          >
            Home
          </span>
          {!isLoggedIn && (
            <div
              onMouseEnter={() => setShowServices(true)}
              onMouseLeave={() => setShowServices(false)}
              className="relative inline-block"
            >
              <span
                className={`cursor-pointer ${
                  showServices ? "th-nav__link__active" : "th-nav__link"
                }`}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent event bubbling
                  setShowServices(!showServices);
                }}
              >
                Services
              </span>
              <Services
                isOpen={showServices}
                onClose={() => setShowServices(false)}
                isClickTriggered={true}
              />
            </div>
          )}
          <span
            className={`cursor-pointer ${
              location.pathname === "/about-us" && !showServices
                ? "th-nav__link__active"
                : "th-nav__link"
            }`}
            onClick={() => navigate("/about-us")}
          >
            About Us
          </span>
          <span
            className={`cursor-pointer ${
              location.pathname === "/contact" && !showServices
                ? "th-nav__link__active"
                : "th-nav__link"
            }`}
            onClick={() => navigate("/contact")}
          >
            Contact
          </span>
          {isLoggedIn && role === "customer" && (
            <span
              className={`cursor-pointer ${
                location.pathname === "/cart" && !showServices
                  ? "th-nav__link__active"
                  : "th-nav__link"
              }`}
              onClick={() => navigate("/cart")}
            >
              Cart <span>({totalCount})</span>
            </span>
          )}
          {isLoggedIn && role === "customer" && (
            <span
              className={`cursor-pointer ${
                location.pathname === "/myorder" && !showServices
                  ? "th-nav__link__active"
                  : "th-nav__link"
              }`}
              onClick={() => navigate("/myorder")}
            >
              MyOrders
              {/* <span>({totalCount})</span> */}
            </span>
          )}
        </div>
        <div className="th-nav__login">
          <div className="th-nav__login__container">
            {!isLoggedIn ? (
              <>
                <span
                  className="th-nav__auth"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  Log-in / Sign-Up
                </span>
                <div
                  className="th-nav__provider"
                  onClick={() => navigate("/service-provider/login")}
                >
                  <span className="th-nav__provider__txt">Vendor Login</span>
                </div>
              </>
            ) : (
              <>
                <span
                  className="th-nav__auth flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={logoutAccount}
                >
                  Logout
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.54199 5.86067C2.54199 4.0044 4.09797 2.54199 5.96278 2.54199H9.6083C11.4737 2.54199 13.0298 4.00429 13.0298 5.86067V6.53232C13.0298 6.90009 12.7317 7.19822 12.3639 7.19822C11.9962 7.19822 11.698 6.90009 11.698 6.53232V5.86067C11.698 4.78711 10.7864 3.87378 9.6083 3.87378H5.96278C4.78554 3.87378 3.87378 4.787 3.87378 5.86067V13.873C3.87378 14.9467 4.78554 15.8599 5.96278 15.8599H9.61578C10.7896 15.8599 11.698 14.9499 11.698 13.8809V13.2021C11.698 12.8343 11.9962 12.5362 12.3639 12.5362C12.7317 12.5362 13.0298 12.8343 13.0298 13.2021V13.8809C13.0298 15.7332 11.4765 17.1917 9.61578 17.1917H5.96278C4.09798 17.1917 2.54199 15.7293 2.54199 13.873V5.86067ZM7.43664 9.67874C7.43664 9.31098 7.73478 9.01285 8.10254 9.01285H14.9132L14.0077 8.11137C13.7471 7.8519 13.7462 7.43028 14.0056 7.16966C14.2651 6.90903 14.6867 6.90809 14.9473 7.16756L16.991 9.20216C17.1149 9.32309 17.1919 9.49193 17.1919 9.67874C17.1919 9.8675 17.1133 10.0379 16.9871 10.1591L14.9474 12.1904C14.6868 12.4499 14.2652 12.4491 14.0057 12.1885C13.7462 11.9279 13.7471 11.5063 14.0076 11.2468L14.9135 10.3446H8.10254C7.73478 10.3446 7.43664 10.0465 7.43664 9.67874Z"
                      fill="#383838"
                    />
                  </svg>
                </span>
                {role !== "provider" && (
                  <span
                    className="th-nav__auth flex align-items-center gap-2 align-self-center"
                    style={{
                      padding: "12px",
                    }}
                    onClick={() => navigate("/dashboard/my-account")}
                  >
                    {user?.firstName || "User"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M17.625 10C17.625 5.85757 14.2674 2.5 10.125 2.5C5.98257 2.5 2.625 5.85757 2.625 10C2.625 14.1416 5.98257 17.5 10.125 17.5C14.2674 17.5 17.625 14.1416 17.625 10Z"
                        stroke="#383838"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.83496 16.1452C6.00524 14.8235 7.18091 13.356 10.0998 13.356C13.0512 13.356 14.2188 14.8317 14.3809 16.1695"
                        stroke="#383838"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.8487 8.60558C12.8487 10.1226 11.6195 11.3518 10.1025 11.3518C8.58549 11.3518 7.35547 10.1226 7.35547 8.60558C7.35547 7.08857 8.58549 5.85938 10.1025 5.85938C11.6195 5.85938 12.8487 7.08857 12.8487 8.60558Z"
                        stroke="#383838"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="th-nav__sm">
        <div className="th-nav__logo" onClick={() => navigate("/")}>
          <img src={LOGO} alt="thurent" width={"120px"} />
        </div>
        {!toggleSidebar && (
          <Button
            icon={"pi pi-bars"}
            rounded
            text
            aria-label="Hamburger"
            style={{
              backgroundColor: "white",
              color: "#383838",
              borderRadius: "50%",
              border: "none",
              width: "40px",
              height: "40px",
            }}
            onClick={() => setToggleSidebar(!toggleSidebar)}
          />
        )}
        <Sidebar
          visible={toggleSidebar}
          header={
            <div
              className="th-nav__logo"
              onClick={() => {
                if (isLoggedIn) {
                  navigate("/dashboard");
                } else {
                  navigate("/");
                }
              }}
            >
              <img src={LOGO} alt="thurent" width={"120px"} />
            </div>
          }
          onHide={() => setToggleSidebar(false)}
        >
          <div className="flex flex-column gap-5 my-3 h-screen">
            <span
              className={`cursor-pointer th-nav__link th-nav__sm__link th-nav__sm__link__dropdown__item`}
              onClick={() => navigate("/")}
            >
              Home
            </span>
            <span className={`th-nav__link th-nav__sm__link`}>
              Services <i className="pi pi-angle-down"></i>
              <ul className="th-nav__sm__link__dropdown flex flex-column gap-3 list-none">
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/ai-enabled-event-details")}
                >
                  Checklist / To-do list
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/book-catering")}
                >
                  Order Catering
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() =>
                    navigate("/service/rental-services-for-events")
                  }
                >
                  Rent From Tent Houses
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/invite")}
                >
                  Send Invitation
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/hire-a-priest")}
                >
                  Book A Priest
                </li>
              </ul>
            </span>
            <span
              className={`cursor-pointer th-nav__link th-nav__sm__link th-nav__sm__link__dropdown__item`}
              onClick={() => navigate("/about-us")}
            >
              About Us
            </span>
            <span
              className={`cursor-pointer th-nav__link th-nav__sm__link th-nav__sm__link__dropdown__item`}
              onClick={() => navigate("/contact")}
            >
              Contact
            </span>
            {isLoggedIn && (
              <span
                className={`cursor-pointer ${
                  location.pathname === "/cart" && !showServices
                    ? "th-nav__link__active"
                    : "th-nav__link"
                }`}
                onClick={() => navigate("/cart")}
              >
                Cart <span>({totalCount})</span>
              </span>
            )}
            {isLoggedIn && (
              <span
                className={`cursor-pointer ${
                  location.pathname === "/myorder" && !showServices
                    ? "th-nav__link__active"
                    : "th-nav__link"
                }`}
                onClick={() => navigate("/myorder")}
              >
                myorder
                {/* <span>({totalCount})</span> */}
              </span>
            )}
          </div>
          <div className={`th-nav__sm__footer ${!isLoggedIn && "w-auto"}`}>
            {!isLoggedIn ? (
              <>
                <span
                  className="th-nav__auth"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  Log-in / Sign-Up
                </span>
                <div
                  className="th-nav__provider"
                  onClick={() => navigate("/service-provider/login")}
                >
                  <span className="th-nav__provider__txt">VENDOR LOGN</span>
                </div>
              </>
            ) : (
              <>
                <span
                  className="th-nav__auth  w-full flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={logoutAccount}
                >
                  Logout
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.54199 5.86067C2.54199 4.0044 4.09797 2.54199 5.96278 2.54199H9.6083C11.4737 2.54199 13.0298 4.00429 13.0298 5.86067V6.53232C13.0298 6.90009 12.7317 7.19822 12.3639 7.19822C11.9962 7.19822 11.698 6.90009 11.698 6.53232V5.86067C11.698 4.78711 10.7864 3.87378 9.6083 3.87378H5.96278C4.78554 3.87378 3.87378 4.787 3.87378 5.86067V13.873C3.87378 14.9467 4.78554 15.8599 5.96278 15.8599H9.61578C10.7896 15.8599 11.698 14.9499 11.698 13.8809V13.2021C11.698 12.8343 11.9962 12.5362 12.3639 12.5362C12.7317 12.5362 13.0298 12.8343 13.0298 13.2021V13.8809C13.0298 15.7332 11.4765 17.1917 9.61578 17.1917H5.96278C4.09798 17.1917 2.54199 15.7293 2.54199 13.873V5.86067ZM7.43664 9.67874C7.43664 9.31098 7.73478 9.01285 8.10254 9.01285H14.9132L14.0077 8.11137C13.7471 7.8519 13.7462 7.43028 14.0056 7.16966C14.2651 6.90903 14.6867 6.90809 14.9473 7.16756L16.991 9.20216C17.1149 9.32309 17.1919 9.49193 17.1919 9.67874C17.1919 9.8675 17.1133 10.0379 16.9871 10.1591L14.9474 12.1904C14.6868 12.4499 14.2652 12.4491 14.0057 12.1885C13.7462 11.9279 13.7471 11.5063 14.0076 11.2468L14.9135 10.3446H8.10254C7.73478 10.3446 7.43664 10.0465 7.43664 9.67874Z"
                      fill="#383838"
                    />
                  </svg>
                </span>
                <span
                  className="th-nav__auth w-full flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/dashboard/my-account")}
                >
                  {user?.firstName || "User"}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.625 10C17.625 5.85757 14.2674 2.5 10.125 2.5C5.98257 2.5 2.625 5.85757 2.625 10C2.625 14.1416 5.98257 17.5 10.125 17.5C14.2674 17.5 17.625 14.1416 17.625 10Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.83496 16.1452C6.00524 14.8235 7.18091 13.356 10.0998 13.356C13.0512 13.356 14.2188 14.8317 14.3809 16.1695"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.8487 8.60558C12.8487 10.1226 11.6195 11.3518 10.1025 11.3518C8.58549 11.3518 7.35547 10.1226 7.35547 8.60558C7.35547 7.08857 8.58549 5.85938 10.1025 5.85938C11.6195 5.85938 12.8487 7.08857 12.8487 8.60558Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </>
            )}
          </div>
        </Sidebar>
      </div>
    </>
  );
}

export default Navbar;
